import Cookies from 'js-cookie';

export const AUTH_KEY = 'QualleAuth';

export const getAuth = () => {
  return Cookies.getJSON(AUTH_KEY);
};

export const setAuth = (auth) => {
  Cookies.set(AUTH_KEY, JSON.stringify(auth));
};

export const clearAuth = () => {
  Cookies.remove(AUTH_KEY);
};
